// leave off @2x/@3x
const images = {
    sideImage: require('../assets/globe_bg.jpg'),
    logoImage: require('../assets/logo.png'),
    logoImage1: require('../assets/logowhite.png'),
};

export default images;
